import { render, staticRenderFns } from "./PanelMenuButton.vue?vue&type=template&id=3a5ee654&scoped=true&"
import script from "./PanelMenuButton.vue?vue&type=script&lang=js&"
export * from "./PanelMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./PanelMenuButton.vue?vue&type=style&index=0&id=3a5ee654&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ee654",
  null
  
)

export default component.exports